import { render, staticRenderFns } from "./OfferShow.vue?vue&type=template&id=96476586&"
import script from "./OfferShow.vue?vue&type=script&lang=js&"
export * from "./OfferShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports